import { Component, Input, inject } from '@angular/core';
import { Client } from '../../../core/models/client.model';
import { ClientsService } from '../../../core/services/clients.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';


@Component({
    selector: 'app-send-direct-test-message',
    templateUrl: './send-direct-test-message.component.html',
    styleUrls: ['./send-direct-test-message.component.scss'],
    imports: [FaIconComponent]
})
export class SendDirectTestMessageComponent {
  private clientsService = inject(ClientsService);

  @Input() client: Client;

  sendingMessage = false;
  errorMessage = null;

  sendMessageClick() {
    this.sendingMessage = true;
    this.errorMessage = null;

    this.clientsService.sendTestDirectMessage(this.client.id).subscribe(
      () => {
        this.sendingMessage = false;
      },
      (err: HttpErrorResponse) => {
        this.sendingMessage = false;
        this.errorMessage = err.error.error;
      }
    );
  }
}
